import React from 'react';
import { SidebarTab } from './_sidebar-tab/sidebar-tab';
import { WebsiteBuilderSidebarTab } from '../website-builder-sidebar.viewmodel';
import { MinimizeIcon } from '../../../../global/icons/icons';
import './sidebar-header.scss';

type SidebarHeaderProps = {
    activeTab: WebsiteBuilderSidebarTab;
    onTabClick: (tab: WebsiteBuilderSidebarTab) => void;
    onMinimize: () => void;
    pageTabLabel: React.ReactElement | string;
    editHubTabLabel?: React.ReactElement | string;
};

export const SidebarHeader = ({ activeTab, onTabClick, onMinimize, pageTabLabel, editHubTabLabel }: SidebarHeaderProps) => {
    return (
        <div className='sidebar-header'>
            <SidebarTab
                label={pageTabLabel}
                isActive={activeTab === WebsiteBuilderSidebarTab.ManagePage}
                onClick={() => onTabClick(WebsiteBuilderSidebarTab.ManagePage)}
            />
            {editHubTabLabel && (
                <SidebarTab
                    label={editHubTabLabel}
                    isActive={activeTab === WebsiteBuilderSidebarTab.EditHub}
                    onClick={() => onTabClick(WebsiteBuilderSidebarTab.EditHub)}
                />
            )}
            <div className='sidebar-header__actions'>
                <button className='sidebar-header__minimize-btn' onClick={onMinimize}>
                    <MinimizeIcon />
                </button>
            </div>
        </div>
    );
};
